module.exports = "/out/a263fe20d2ff027d01af0d3b43d3b764.svg";